// These dimensions also drive the v2 card styles, so the row budget matches
// what is actually rendered. Use card pixels because mobile sizes are fluid.
export const textAssetPreviewMetrics = {
    heightOffset: 5,
    padding: 8,
    titleLineHeight: 20,
    titleGap: 5,
    fieldLineHeight: 17,
    textLineHeight: 16.2,
};

export function textAssetPreviewLayout(assetSize, selectedFieldCount, hasMainText) {
    const {heightOffset, padding, titleLineHeight, titleGap, fieldLineHeight, textLineHeight} = textAssetPreviewMetrics;
    const contentHeight = Math.max(0, assetSize - heightOffset - padding * 2 - titleLineHeight - titleGap);
    let fieldCapacity = Math.floor(contentHeight / fieldLineHeight);

    if (hasMainText) {
        // Keep the existing small-card density where it fits, then share larger
        // cards between metadata and Main Text. Always reserve one text line.
        const preferredFields = Math.max(3, Math.floor(contentHeight / (fieldLineHeight * 2)));
        fieldCapacity = Math.min(preferredFields, Math.max(0, Math.floor((contentHeight - textLineHeight) / fieldLineHeight)));
    }

    const fieldCount = Math.min(selectedFieldCount, fieldCapacity);
    const mainTextLines = hasMainText ? Math.max(1, Math.floor((contentHeight - fieldCount * fieldLineHeight) / textLineHeight)) : 0;
    return {fieldCount, mainTextLines};
}
